"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiTextCell = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var storm_ui_1 = require("@amzn/storm-ui");
var multi_text_cell_styles_1 = require("./multi_text_cell.styles");
var global_styles_1 = require("../../Global/global.styles");
var MultiTextCellInternal = function (props) {
    return (react_1.default.createElement(global_styles_1.FlexContainer, { onClick: props.cell.value.onClick },
        props.cell.value.icon && react_1.default.createElement(multi_text_cell_styles_1.CellIcon, { icon: props.cell.value.icon }),
        react_1.default.createElement(multi_text_cell_styles_1.FlexContainerVertical, null, props.cell.value.lines.map(function (text, index) {
            return index === 0 || !props.cell.value.focusPrimary ? (react_1.default.createElement(multi_text_cell_styles_1.StyledTextRow, { key: index }, text)) : (react_1.default.createElement(multi_text_cell_styles_1.StyledTextRowSecondary, { key: index }, text));
        }))));
};
var MultiTextCell = function (props) {
    return ((props.cell.value.href &&
        ((props.cell.value.hrefExternal && (react_1.default.createElement(storm_ui_1.Link, { href: props.cell.value.href, target: '_blank', rel: "noopener noreferrer" },
            react_1.default.createElement(MultiTextCellInternal, __assign({}, props))))) || (react_1.default.createElement(react_router_dom_1.Link, { to: props.cell.value.href },
            react_1.default.createElement(MultiTextCellInternal, __assign({}, props)))))) || react_1.default.createElement(MultiTextCellInternal, __assign({}, props)));
};
exports.MultiTextCell = MultiTextCell;
